module.exports = __webpack_public_path__ + "img/pop_wallet_logo_bitkeep@2x.f1a1b99b.png";